import Vue from 'vue'
import Vuetify from 'vuetify/lib'
//import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.css'
import { Ripple } from 'vuetify/lib/directives'
import { i18n } from './i18n'

Vue.use(Vuetify,{
  directives: {
    Ripple
  }
})

export default new Vuetify({
  icons: {
    // iconfont: 'mdiSvg',
  },
  // icons: {
  //   iconfont: 'mdi' // default - only for display purposes
  // },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  breakpoint: {
    thresholds: {
      md: 1380,
      lg: 1904,
    },
    scrollBarWidth: 8,
  },
  theme: {
    disable: true,
    // dark: eval(localStorage.getItem('darkTheme')),
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        accent: '#82B1FF',
        error: '#FF5252',
        green_chosen: '#7DE199',
        green_chosen_light: '#D9EEEC',
        info: '#2196F3',
        light_black: '#808080',
        main__black: '#000000',
        main__green: '#b0dbd8',
        main__green_darken: '#86b5b2',
        main__light_green: '#EBF6F5',
        primary: '#1976D2',
        secondary: '#424242',
        secondary__green_active: '#1BA57D',
        secondary__green_approved: '#A4EAB8',
        secondary__green_approved_darken: '#79c78f',
        secondary__green_chosen: '#D8F1F0',
        secondary__green_not_active: '#6A8382',
        secondary__red: '#FF7D60',
        secondary__white: '#FFFFFF',
        secondary__yellow: '#F8F054',
        secondary__yellow_chosen: '#F2DDA6',
        success: '#4CAF50',
        warning: '#FB8C00',
      }, 
      dark: {
        primary: '#2196F3',
        secondary: '#424242',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
        main__black: '#feffff',
        main__green: '#002723',
        main__green_darken: '#86b5b2',
        main__light_green: '#191e19',
        secondary__green_chosen: '#103027',
        green_chosen: '#7DE199',
        green_chosen_light: '#121618',
        secondary__green_not_active: '#98adae',
        secondary__green_active: '#1BA57D',
        secondary__green_approved: '#A4EAB8',
        secondary__green_approved_darken: '#79c78f',
        secondary__yellow: '#F8F054',
        secondary__red: '#FF7D60',
        secondary__white: '#4e5857',
        light_black: '#808080',
        secondary__yellow_chosen: '#F2DDA6'
      }, 
    },  
  },
})